
export const API_CALL = `https://hrmsapi.gtentechnologies.com`